let lastActivityTime = Date.now();
let refreshTimeout = null;
let isRefreshing = false;

const ACTIVITY_CHECK_INTERVAL = 5 * 60 * 1000;
const TOKEN_REFRESH_THRESHOLD = 10 * 60 * 1000;

export const trackUserActivity = () => {
  lastActivityTime = Date.now();
};

const shouldRefreshToken = () => {
  const timeSinceLastActivity = Date.now() - lastActivityTime;
  return timeSinceLastActivity < TOKEN_REFRESH_THRESHOLD;
};

const refreshToken = async () => {
  if (isRefreshing) return;

  try {
    isRefreshing = true;
    const tokenData = localStorage.getItem('token');
    if (!tokenData) {
      console.error('No token found');
      return;
    }

    const tokenString = JSON.parse(tokenData)?.token;
    if (!tokenString) {
      console.error('Invalid token format');
      return;
    }

    const response = await fetch('/api/users/refresh_token', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${tokenString}`,
      }
    });

    if (!response.ok) {
      throw new Error('Token refresh failed');
    }

    const json = await response.json();
    if (json.token) {
      // Update token in localStorage with the new token
      localStorage.setItem('token', JSON.stringify({
        token: json.token,
        expiration: new Date(Date.now() + 12 * 60 * 60 * 1000).toISOString() // 12 hours from now
      }));
      console.log('Token refreshed successfully');
    }
  } catch (error) {
    console.error('Failed to refresh token:', error);
    // If refresh fails, we might want to log the user out
    if (error.message === 'Token refresh failed') {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
  } finally {
    isRefreshing = false;
  }
};

export const startActivityMonitoring = () => {
  if (refreshTimeout) {
    clearTimeout(refreshTimeout);
  }

  refreshTimeout = setInterval(async () => {
    if (shouldRefreshToken()) {
      await refreshToken();
    }
  }, ACTIVITY_CHECK_INTERVAL);

  const activityEvents = [
    'mousedown', 'keydown', 'scroll', 'touchstart',
    'mousemove', 'keyup', 'click', 'input',
    'change', 'focus', 'blur'
  ];

  activityEvents.forEach(event => {
    document.addEventListener(event, trackUserActivity, { passive: true });
  });

  document.addEventListener('submit', async (e) => {
    trackUserActivity();
    await refreshToken();
  }, { passive: true });
};

export const stopActivityMonitoring = () => {
  if (refreshTimeout) {
    clearTimeout(refreshTimeout);
    refreshTimeout = null;
  }

  // Remove event listeners
  const activityEvents = [
    'mousedown', 'keydown', 'scroll', 'touchstart',
    'mousemove', 'keyup', 'click', 'input',
    'change', 'focus', 'blur', 'submit'
  ];

  activityEvents.forEach(event => {
    document.removeEventListener(event, trackUserActivity);
  });
};
